import { Grid, Paper, Typography, useTheme, PaletteMode } from "@mui/material";
import React, { FunctionComponent, useEffect, useState } from "react";
import "./ProjectsShowCase.css";
import { Project } from "../../interfaces/InformationInterface";
import { nanoid } from "nanoid";
interface ProjectsShowCaseProps {
  projects: Project[];
  justifyContent?: string;
  onClick?:(project:Project)=>any;
}

const idComponent = "projectsIdAnimation";
const ProjectsShowCase: FunctionComponent<ProjectsShowCaseProps> = (props) => {
  const [IsinView, setIsInView] = useState(false);
  const [firstTime, setFirstTime] = useState(true); 
  const theme = useTheme();
  const { projects, justifyContent,onClick } = props;
  useEffect(() => {
    const Obs = new IntersectionObserver(([el]) => {
      //if el not found
      if (!el) return;
      if (el.intersectionRatio > 0) {
        setIsInView(true);
      }
    });
    const el = document.querySelector(`.${idComponent}`);
    if (el) Obs.observe(el);
  });

  const projectsCmpt = React.useMemo(
    () =>
      projects.map(
        (project, index) => {
          const { title, miniDescription, url = "", iconToolUrls } = project;
          return (
            <Grid item 
              key={Math.random()}
              className="card"
              onClick={()=>onClick?.(project)}
              onAnimationEnd={()=>setFirstTime(false)}
              style={{
                animation: IsinView
                  ? `fade-in ${firstTime? "0.5" : "0"}s forwards ${
                      firstTime? (index + 1) * 0.1 : 0
                    }s`
                  : "",
              }}
            >
              <MiniProject
                index={index}
                title={title}
                description={miniDescription}
                url={url}
                iconsUrl={iconToolUrls}
                lightMode={theme.palette.mode}
              />
            </Grid>
          );
        }
      ),
    [IsinView, theme.palette.mode]
  );
  return (
    <>
      {/* <Typography variant="h3" textAlign={"center"}>Projects</Typography> */}
      <Grid
        spacing={1}
        id="ProjectsShowCase"
        className={idComponent}
        container
        justifyContent={justifyContent}
        onAnimationEnd={()=>{}}
      >
        {projectsCmpt}
      </Grid>
    </>
  );
};

interface MiniProjectProps {
  title: string;
  description: string;
  url?: string;
  iconsUrl?: string[];
  lightMode: PaletteMode;
  index: Number;
}

const MiniProject: FunctionComponent<MiniProjectProps> = (props) => {
  const {
    title,
    description,
    url = "",
    iconsUrl = [],
    lightMode,
    index,
  } = props;
  const icons = React.useMemo(
    () =>
      iconsUrl.map((urlIcon) => (
        <Grid item key={Math.random()}>
          <img
            className="imgIcon"
                referrerPolicy="no-referrer"
                style={{
              backgroundColor: lightMode === "dark" ? "#f5f5f5" : "none",
            }}
            src={urlIcon}
            alt="icons"
          />
        </Grid>
      )),
    []
  );
  return (
    <Paper
      elevation={1}
      className="MiniProjectProps"
      // onClick={() => (window.location.href = `projects?id=${index}`)}
    >
      <Grid container direction={"column"} spacing={1}>
        <Grid item>
          <Grid container direction="row" spacing={1}>
            {icons}
          </Grid>
        </Grid>
        <Grid item>
          <Typography className="titleMiniProject">{title}</Typography>
        </Grid>
        <Grid item>
          <Typography variant="body1">{description}</Typography>
        </Grid>
        {/* <Grid item><div style={{color:lightMode==="dark"? "lightskyblue" : "blue"}} className="linkShowMore" onClick={()=>window.location.href='/project'}>More detail</div></Grid> */}
        {url && (
          <Grid
            item
            style={{ color: lightMode === "dark" ? "lightskyblue" : "blue" }}
          >
            <div
              className="linkShowMore"
              onClick={(e) => {
                e.stopPropagation();
                window.open(url);
              }}
            >
              View Project
            </div>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

export default ProjectsShowCase;
